import mapboxgl from 'mapbox-gl';

let id = 'mapbox';

window.addEventListener('load', function () {
    mapboxgl.accessToken = 'pk.eyJ1IjoicGVvcGxlc2NvbXBhbnkiLCJhIjoiY2lqdzhwNXpqMDR2Y3ZxbTVvd3I3dDk5dyJ9.p8kQ7CEv7ALo9YAoxCXlLw';
    let map = new mapboxgl.Map({
        container: id,
        style: 'mapbox://styles/mapbox/satellite-streets-v9',
        center: [
            -87.6826,
            35.0637,
        ],
        zoom: 10,
        scrollZoom: false,
    });

    map.on('style.load', function () {
        if (!map.getSource('primary')) {
            map.addSource('primary', {
                'type': 'geojson',
                data: document.getElementById(id).getAttribute('mapbox-geojson'),
            });
        }
        if (!map.getLayer('primary')) {
            map.addLayer({
                'id': 'primary',
                'type': 'line',
                'source': 'primary',
                'layout': {},
                'paint': {
                    'line-color': '#e23e21',
                    'line-width': 4,
                },
            });
        }
    });

    map.on('load', function () {
        // Add zoom and rotation controls to the map.
        map.addControl(new mapboxgl.NavigationControl(), 'top-left');
    });
});

